import React from 'react';
import styles from './NewCaption.module.scss';

const NewCaption: React.FC = () => <span className={styles.newCaption}>NEW</span>;

export default NewCaption;
